import { Autocomplete, TextField } from '@mui/material';
import { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../store';

const mapStateToProps = (state: RootState) => ({
    customerGroups: state.customerGroups.customerGroups
});
type OwnProps = {
    selectedCustomerGroup: number | undefined;
    onSelectCustomerGroup: (customerId: number | null) => void;
    disabled?: boolean;
    label: string;
    error?: boolean;
    helperText?: string;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const CustomerGroupSelector = ({
    customerGroups,
    selectedCustomerGroup,
    onSelectCustomerGroup,
    disabled,
    label,
    error,
    helperText
}: Props) => {
    return (
        <Autocomplete
            value={selectedCustomerGroup}
            onChange={(_: SyntheticEvent<Element, Event>, newValue: number | null) =>
                onSelectCustomerGroup(newValue)
            }
            disabled={disabled}
            getOptionLabel={customerGroup =>
                customerGroup != null && customerGroups[customerGroup] != null
                    ? `${customerGroups[customerGroup!]?.externalReference} - ${
                          customerGroups[customerGroup!].name
                      }`
                    : ''
            }
            id="customerGroup"
            options={Object.values(customerGroups).map(c => c.customerGroupId ?? null)}
            clearOnEscape
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    disabled={disabled}
                    error={!!error}
                    helperText={helperText}
                />
            )}
        />
    );
};

export default connect(mapStateToProps)(CustomerGroupSelector);
